import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { resetPassword } from '../../Api/authApi.js.js';
import { toast } from 'react-toastify';
import '../updateuser/updateuser.css';

const PasswordReset = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const token = new URLSearchParams(location.search).get('token');
    const email = new URLSearchParams(location.search).get('email');

    const [resetData, setResetData] = useState({
        email: email || '',
        password: '',
        password_confirmation: '',
        token: token || '',
    });

    const handleChange = (e) => {
        setResetData({ ...resetData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await resetPassword(resetData);
            toast.success(response.message);
            setResetData({ email: '', password: '', password_confirmation: '', token: '' });
            navigate('/connexion');
        } catch (error) {
            toast.warning(error.response?.data?.message || 'Une erreur est survenue.');
        }
    };

    const LockIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
    );

    const MailIcon = () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
    );

    return (
        <div className="settings-form-page">
            <div className="sfp-header">
                <button className="sfp-back-btn pill-tap" onClick={() => navigate('/connexion')}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <span className="sfp-page-title">Réinitialiser le mot de passe</span>
            </div>

            <div className="sfp-body">
                <p className="sfp-subtitle">Saisis ton nouveau mot de passe</p>

                <form className="sfp-card relief" onSubmit={handleSubmit}>
                    <div className="sfp-field">
                        <span className="sfp-field-icon"><MailIcon /></span>
                        <input
                            className="sfp-input"
                            type="email"
                            name="email"
                            value={resetData.email}
                            onChange={handleChange}
                            placeholder="Adresse e-mail"
                            autoComplete="email"
                        />
                    </div>

                    <div className="sfp-field">
                        <span className="sfp-field-icon"><LockIcon /></span>
                        <input
                            className="sfp-input"
                            type="password"
                            name="password"
                            value={resetData.password}
                            onChange={handleChange}
                            placeholder="Nouveau mot de passe"
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="sfp-field">
                        <span className="sfp-field-icon"><LockIcon /></span>
                        <input
                            className="sfp-input"
                            type="password"
                            name="password_confirmation"
                            value={resetData.password_confirmation}
                            onChange={handleChange}
                            placeholder="Confirmer le mot de passe"
                            autoComplete="new-password"
                        />
                    </div>

                    <button type="submit" className="sfp-submit pill-tap">
                        Réinitialiser
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PasswordReset;
